import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { Store } from '@ngxs/store';
import moment from 'moment';
import { ORDER_TYPES } from 'src/app/app-constants';
import { MembersState } from 'src/app/dashboard/stores/members';
import { OrgState } from 'src/app/dashboard/stores/org';
import { OrgModel } from 'src/app/models/org.model';
import { ProductModel } from 'src/app/models/product.model';
import { ItemModel } from 'src/app/models/sale-item.model';
import { SaleModel } from 'src/app/models/sale.model';

import { PrintReceiptService } from '../../print-receipt-service/print-receipt.service';
import { ClImageCompatComponent } from '../cl-image-compat/cl-image-compat.component';

interface IPrintPage {
    orgName?: string;
    email?: string;
    contactNumber?: string;
    strn?: number;
    ntn?: string;
    items?: Array<ProductModel>;
    image?: string;
    kitchenName?: string;
    address?: string;
}
@Component({
    standalone: true,
    imports: [CommonModule, ClImageCompatComponent, TranslocoModule],
    selector: 'app-print-receipt',
    templateUrl: './print-receipt.component.html',
    styleUrls: ['./print-receipt.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PrintReceiptComponent {
    invoiceData: SaleModel;

    kitchen_content;
    orderType = ORDER_TYPES;
    pages: Array<IPrintPage>;
    orgType: OrgModel;
    currentUser;
    printDate: string;
    remainingAmount: number;

    constructor(
        public PrintReceiptService: PrintReceiptService,
        private store: Store
    ) {
        this.PrintReceiptService.getReceptTokitchan().subscribe((resp) => {
            this.currentUser = this.store.selectSnapshot(MembersState.currentUser);
            this.orgType = this.store.selectSnapshot(OrgState.org);
            this.receiptToKitchen(resp);
        });
        this.PrintReceiptService.getReceiptToCustomer().subscribe((resp) => {
            this.currentUser = this.store.selectSnapshot(MembersState.currentUser);
            this.orgType = this.store.selectSnapshot(OrgState.org);
            this.receiptToCustomer(resp);
        });
    }

    getSubtotal(items: Array<ItemModel>): number {
        if (Array.isArray(items)) {
            return items.reduce((acc, item) => acc + +item.quantity * +(item.unit_price || item.price), 0);
        }
    }

    getPage(item: ProductModel[], config = {}): IPrintPage {
        return {
            items: [...item],
            orgName: this.orgType.name,
            ...config,
        };
    }

    getPages(items) {
        return items.reduce((acc, item) => {
            const key = item?.item?.service_area.id;
            if (acc[key]) {
                acc[key].items.push(item);
            } else {
                acc[key] = this.getPage([item], {
                    kitchenName: item.kitchenNames || 'Kitchen',
                });
            }
            return acc;
        }, {});
    }

    receiptToKitchen(data) {
        this.printDate = moment(new Date()).format('DD-MM-YYYY HH:mm:ss');
        this.invoiceData = data;
        const pagesData = this.getPages([...data.groups[0].group.items]);
        this.pages = Object.values(pagesData);
        this.kitchen_content = true;
        setTimeout(() => {
            window.print();
            this.pages = [];
        }, 1000);
    }

    receiptToCustomer(items) {
        this.printDate = moment(new Date()).format('DD-MM-YYYY HH:mm:ss');
        this.invoiceData = items;
        this.kitchen_content = false;
        this.remainingAmount = Math.abs(+(this.invoiceData?.total - +this.invoiceData?.received_payment)?.toFixed(2));
        this.pages = [this.getPage([...items.groups[0].group.items])];
        setTimeout(() => {
            window.print();
            this.pages = [];
        }, 1000);
    }

    taxNtnCheck(tax: number): boolean {
        const isTaxEnable: boolean = this.orgType.IsTaxSettingBase;
        if (isTaxEnable) {
            return true;
        } else if (!isTaxEnable && tax) {
            return true;
        } else {
            return false;
        }
    }

    get CurrentUserName(): string {
        const currentUser = this.currentUser?.attributes;
        if (currentUser?.given_name && currentUser.family_name) {
            return currentUser.given_name + ' ' + currentUser.family_name;
        } else if (currentUser?.given_name) {
            return currentUser.given_name;
        } else if (currentUser?.family_name) {
            return currentUser.family_name;
        } else {
            return 'N/A';
        }
    }
}
